import { render, staticRenderFns } from "./DetailDaftarCekGadai.vue?vue&type=template&id=263aa2cb&scoped=true&"
import script from "./DetailDaftarCekGadai.vue?vue&type=script&lang=js&"
export * from "./DetailDaftarCekGadai.vue?vue&type=script&lang=js&"
import style0 from "./DetailDaftarCekGadai.vue?vue&type=style&index=0&id=263aa2cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263aa2cb",
  null
  
)

export default component.exports